<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Choose your Lock';
                }
            },
            component_id: {
                default(){
                    return 'hardware_lock';
                }
            },
            hardwareHandle: {
                required: true
            },
            opening_direction: {
                required: true
            },
            hardwareEscutcheon: {
                required: false,
                default(){
                    return null;
                }
            },
            securedByDesign: {
                required: true
            },
            hingeSide: {
                required: true
            },
            slab: {
                required: true
            },
            frameMaterial: {
                required: false,
                default(){
                    return '';
                }
            },
            doorLocation: {
                required: false,
                default(){
                    return '';
                }
            },
            doorRange: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab, this.opening_direction, this.hardwareHandle, this.securedByDesign, this.frameMaterial, this.hingeSide, this.doorRange);
            },
            url(){
                if (this.hardwareEscutcheon === null || this.hardwareEscutcheon === undefined){
                    return '/api/options/' + this.fabricator + '/hardware-lock?slab=' + this.slab + '&frame_material=' + this.frameMaterial + '&hinge_side=' + this.hingeSide + '&secured_by_design=' + this.securedByDesign + '&hardware_handle=' + this.hardwareHandle + '&opening_direction=' + this.opening_direction + '&door_range=' + this.doorRange + '&door_location=' + this.doorLocation;
                }
                return '/api/options/' + this.fabricator + '/hardware-lock?slab=' + this.slab + '&frame_material=' + this.frameMaterial + '&hinge_side=' + this.hingeSide + '&secured_by_design=' + this.securedByDesign + '&hardware_handle=' + this.hardwareHandle + '&hardware_escutcheon=' + this.hardwareEscutcheon + '&opening_direction=' + this.opening_direction + '&door_range=' + this.doorRange + '&door_location=' + this.doorLocation;
            },
            cache_key(){
                if (this.hardwareEscutcheon === null || this.hardwareEscutcheon === undefined){
                    return '_' + this.slab + '_' + this.hardwareHandle + '_' + this.securedByDesign + '_' + this.frameMaterial + '_' + this.hingeSide + '_' + this.opening_direction + '_' + this.doorRange + '_' + this.doorLocation;
                }
                return '_' + this.slab + '_' + this.hardwareHandle + '_' + this.hardwareEscutcheon + '_' + this.securedByDesign + '_' + this.frameMaterial + '_' + this.hingeSide + '_' + this.opening_direction + '_' + this.doorRange + '_' + this.doorLocation;
            }
        },
        watch: {
            'hardwareHandle': function (val, oldVal) {
                this.localTarget = null;
                this.select_first_after_update = true;
                this.update_options();
            },
            'hardwareEscutcheon': function (val, oldVal) {
                this.localTarget = null;
                this.select_first_after_update = true;
                this.update_options();
            },
            'securedByDesign': function (val, oldVal) {
                this.select_first_after_update = true;
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'frameMaterial': function (val, oldVal) {
                this.update_options();
            },
            'hingeSide': function (val, oldVal) {
                this.update_options();
            },
            'opening_direction': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
